// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Dna,
    DnaOff,
    Dock,
    Dog,
    DollarSign,
    Donut,
    DoorClosed,
    DoorClosedLocked,
    DoorOpen,
    DoorStairwell,
    Dot,
    Download,
    DraftingCompass,
    Drama,
    Drill,
    Drone,
    Droplet,
    DropletOff,
    Droplets,
    Drum,
    Drumstick,
    Dumbbell,
    Ear,
    EarOff,
    Earth,
    EarthLock,
    Eclipse,
    Egg,
    EggFried,
    EggOff,
    Eject,
    Ellipse,
    Ellipsis,
    EllipsisVertical,
    Engine,
    Equal,
    EqualApproximately,
    EqualNot,
    Eraser,
    EthernetPort,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "dna" through "ethernet-port", inclusive. */
const shard: Record<string, LucideIcon> = {
    dna: Dna,
    "dna-off": DnaOff,
    dock: Dock,
    dog: Dog,
    "dollar-sign": DollarSign,
    donut: Donut,
    "door-closed": DoorClosed,
    "door-closed-locked": DoorClosedLocked,
    "door-open": DoorOpen,
    "door-stairwell": DoorStairwell,
    dot: Dot,
    download: Download,
    "drafting-compass": DraftingCompass,
    drama: Drama,
    drill: Drill,
    drone: Drone,
    droplet: Droplet,
    "droplet-off": DropletOff,
    droplets: Droplets,
    drum: Drum,
    drumstick: Drumstick,
    dumbbell: Dumbbell,
    ear: Ear,
    "ear-off": EarOff,
    earth: Earth,
    "earth-lock": EarthLock,
    eclipse: Eclipse,
    egg: Egg,
    "egg-fried": EggFried,
    "egg-off": EggOff,
    eject: Eject,
    ellipse: Ellipse,
    ellipsis: Ellipsis,
    "ellipsis-vertical": EllipsisVertical,
    engine: Engine,
    equal: Equal,
    "equal-approximately": EqualApproximately,
    "equal-not": EqualNot,
    eraser: Eraser,
    "ethernet-port": EthernetPort,
};

export default shard;
